import React, { Component } from 'react';
import { noop } from '../helpers';
import { Editor } from '@tinymce/tinymce-react';
import {TINYMCE_OPTIONS} from '@reliv/tinymce';
import {FieldRendererIntersectionProps, FieldFactoryProps} from '../types';
import {DefaultFieldRenderer} from '../field-renderers';

type Props = FieldRendererIntersectionProps<string> & ExtraProps;
type FFProps = FieldFactoryProps<string> & ExtraProps & State;

interface ExtraProps {
    convertUrls?: boolean;
}

interface State {
    value: string;
    ready: boolean;
}

/**
 * Displays a field as a <textarea> element.
 */
export default class RichTextField extends Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        Renderer: DefaultFieldRenderer,
        convertUrls: true,
        onValueChange: noop,
        value: '&nbsp',
    };

    public state: State = {
        ready: false,
        value: this.props.value,
    };

    private timeout: any;

    public componentDidMount() {
        this.timeout = setTimeout(() => {
            this.setState({ ready: true });
        }, 1);
    }

    public componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    public componentWillReceiveProps(nextProps: Props) {
        const value = nextProps.value;
        if (this.state.value !== value) {
            this.setState({ value });
        }
    }

    private handleEditorChange = (e: any) => {
        const value = `${e}`;
        this.props.onValueChange(value, this.state.value, this.props.name, e);
        this.setState({ value });
    }

    private factory = ({
        name,
        value,
        disabled,
        ready,
        convertUrls,
    }: FFProps) => ready ? <Editor
        textareaName={name}
        init={{...TINYMCE_OPTIONS, convert_urls: convertUrls}}
        value={value}
        onEditorChange={this.handleEditorChange}
        disabled={disabled}
    /> : <p>Loading...</p>

    public render() {
        const {props, state, factory} = this;
        return <props.Renderer {...props} {...state} factory={factory} />;
    }
}
